import Work1 from "../../assets/work-1.png";
import Work2 from "../../assets/work-2.png";
import Work3 from "../../assets/work-3.png";
import Work4 from "../../assets/work-4.png";
import Work5 from "../../assets/work-5.png";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "Outverse",
        description: "A place where community builders can connect around community building, design, product feedback and more.",
        category: ["Frontend", "Backend"],
        url: "https://app.outverse.com",
        repositoryUrl: ""
    },
    {
        id: 2,
        image: Work2,
        title: "Smaugs",
        description: "Smaugs Marketplace is a complete custom DeFi, governance, and NFT ecosystem + marketplace.",
        category: ["Frontend", "React"],
        url: "https://smaugs.com",
        repositoryUrl: ""
    },
    {
        id: 3,
        image: Work3,
        title: "Dlops",
        category: ["Frontend"],
        url: "https://dlopsai.netlify.app",
        repositoryUrl: "https://github.com/trendy0413/dlop_ai_landing"
    },
    {
        id: 4,
        image: Work4,
        title: "Yogaia",
        category: ["Frontend"],
        url: "https://yogaia.com",
        repositoryUrl: ""
    },
    {
        id: 5,
        image: Work5,
        title: "Uptok",
        category: ["Frontend"],
        url: "https://uptok.com",
        repositoryUrl: ""
    }
];

export default Menu;
